import { removeElement, createElement } from '@fullcalendar/core';
var TimelineNowIndicator = /** @class */ (function () {
    function TimelineNowIndicator(headParent, bodyParent) {
        this.headParent = headParent;
        this.bodyParent = bodyParent;
    }
    TimelineNowIndicator.prototype.render = function (coord, isRtl) {
        var styleProps = isRtl ? { right: -coord } : { left: coord };
        this.headParent.appendChild(this.arrowEl = createElement('div', {
            className: 'fc-now-indicator fc-now-indicator-arrow',
            style: styleProps
        }));
        this.bodyParent.appendChild(this.lineEl = createElement('div', {
            className: 'fc-now-indicator fc-now-indicator-line',
            style: styleProps
        }));
    };
    TimelineNowIndicator.prototype.unrender = function () {
        if (this.arrowEl) {
            removeElement(this.arrowEl);
        }
        if (this.lineEl) {
            removeElement(this.lineEl);
        }
    };
    return TimelineNowIndicator;
}());
export default TimelineNowIndicator;
